/**
 * Created by katarinababic on 23.4.25.
 */
import * as React from 'react';
import { useState, useRef } from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { ViewBlock } from '../../../Model/WorkoutLog/ViewBlock';
import { CoachExerciseBlock } from '../../../Model/Coach/Program/Workout/CoachExerciseBlock';
import playIcon from '../../../Assets/Images/play_icon.png';
import { useLanguage } from '../../../Hooks/useLanguage';
import { ExerciseExplanationVideoModal } from './ExerciseExplanationVideoModal';
import { getMediaSmallest } from '../../../Model/Media/Media';

const ImageWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 80px;
  height: 80px;
  margin-right: 12px;
  cursor: pointer;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

const PlayIconButton = styled.img`
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
`;

export type ExerciseImageProps = {
  viewBlock?: ViewBlock;
  coachBlock?: CoachExerciseBlock;
};

export const ExerciseImage: React.FC<ExerciseImageProps> = observer(({ viewBlock, coachBlock }) => {
  const { language } = useLanguage();

  const media = viewBlock?.spotClassMedia || coachBlock?.exercise.imageMedia;
  const imageUrl = media ? getMediaSmallest(media) : undefined;
  if (!imageUrl) return null;

  const alt = viewBlock
    ? viewBlock.exercise.localeName(language)
    : coachBlock
      ? coachBlock.exercise.localeName(language)
      : '';

  return (
    <ImageWrapper>
      <Image src={imageUrl} alt={alt} />
      <PlayIconButton src={playIcon} alt="Play" />
    </ImageWrapper>
  );
});
